import { useEffect, useState } from "react";
import { updatePagesSectionForm } from "../../lib/actions";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DropDownFilterPaginations from "../../components/GDropDownList/DropDownFilterPaginations";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { FiUploadCloud } from "react-icons/fi";
import { ThreeDot } from "react-loading-indicators";
import { Editor } from '@tinymce/tinymce-react';

export default function EditPagesSectionUi({data, pagesData, search}) {

    const {pageSectionId} = useParams();
    const nav = useNavigate();
    const [pageID, setPageID] = useState(null)
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;
    const [descriptionAr, setDescriptionAr] = useState(null);
    const [descriptionEn, setDescriptionEn] = useState(null);


    useEffect(() => {
        setDescriptionAr(data?.description?.ar);
        setDescriptionEn(data?.description?.en);
        setImage(data?.image);
        setPageID(data?.page_id);
    }, [data])
    
    const onchange = (e) => {
        setPageID(e);
    };
    
    const onChangeDescriptionEnValue = (e) => {
        setDescriptionEn(e);
    };

    const onChangeDescriptionArValue = (e) => {
        setDescriptionAr(e);
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();

        const form = e.target;
        const formData = new FormData(form);

        formData.set('description_ar', descriptionAr);
        formData.set('description_en', descriptionEn);

        const result = await updatePagesSectionForm(pageSectionId, formData, navigate);
        setLoading(false);
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setImage(URL.createObjectURL(file));
        }
    };

    const handleDeleteImage = () => {
        setImage(null);
    };

    const navigate = (route) => {
        nav(route);
    };

    if (Object.keys(data)?.length < 1 ){
        return <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" /></div> 
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1  md:grid-cols-2 sm:grid-cols-1 gap-3 pb-3">
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "title in arabic" : "الاسم بالعربي "} </label>
                    <input
                        type="text"
                        defaultValue={data?.title?.ar}
                        name="title_ar"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter name in arabic " : "ادخل العنوان باللغة العربية"}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "title in english" : "الاسم بالانجليزي "} </label>
                    <input
                        type="text"
                        defaultValue={data?.title?.en}
                        name="title_en"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter name in english " : "أدخل العنوان باللغة الانجليزية"}
                    />
                </div>
                <div className="mb-4 md:col-span-2">
                    <label className="block text-white mb-2">
                        {currentLang === "en" ? "description in arabic" : "الوصف بالعربية"}
                    </label>
                    <Editor
                        onEditorChange={(e)=> onChangeDescriptionArValue(e)}
                        value={descriptionAr}
                        apiKey='ime80vsvlhk1vw6zpyla5ls253smuovbrmqu2ucv1bksnhex'
                        init={{
                            plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
                            toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                        }}
                        initialValue= {descriptionAr ? descriptionAr : currentLang === "en" ? "description in arabic" : "الوصف بالعربية"}
                    />

                </div>
                <div className="my-10 md:col-span-2">
                    <label className="block text-white mb-2">
                        {currentLang === "en" ? "description in english" : "الوصف بالإنجليزية"}
                    </label>
                    <Editor
                        onEditorChange={(e)=> onChangeDescriptionEnValue(e)}
                        value={descriptionEn}
                        apiKey='ime80vsvlhk1vw6zpyla5ls253smuovbrmqu2ucv1bksnhex'
                        init={{
                            plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
                            toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                        }}
                        initialValue={descriptionEn ? descriptionEn : currentLang === "en" ? "description in english" : "الوصف بالإنجليزية"}
                    />
                </div>
                <div className="my-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "page" : "الصفحة"}</label>
                    <DropDownFilterPaginations search={search} options={pagesData} value={pageID} onchange={onchange} defaultText={currentLang === "en" ? "Select the page" : "أختر الصفحة "} paramkey="page_id" />
                </div>
            </div>
            <div className="mb-4">
                <label className="block text-white mb-6">{currentLang === "en" ? "photo" : "الصورة"}</label>
                <div className="flex justify-center items-center">
                    <div className="bg-thirdly sm:w-[50%] w-[100%] p-6 rounded-2xl border-2 border-dashed border-gray-200">
                            {/* <label className="block text-sm font-medium text-gray-700 mb-4">الصورة الرئيسية</label> */}
                        <div className="relative group">
                            <div className={`flex flex-col items-center justify-center  h-48 ${!image ? 'bg-furthly' : 'bg-transparent'} rounded-xl transition-all`}>
                                    {!image ? (
                                        <>
                                            <FiUploadCloud className="w-12 h-12 text-white mb-3 group-hover:text-secondary transition-colors" />
                                            <span className="text-sm text-white group-hover:text-secondary transition-colors">
                                               {currentLang === "en" ? "click to upload a photo" : " انقر لرفع الصورة"}
                                            </span>
                                        </>
                                    ) : (
                                        <div className="relative w-full h-full">
                                            <img src={image} alt="الصورة الملتقطة" className="w-full h-full object-contain rounded-xl" />
                                            <button type="button" className="absolute top-2 left-2 z-50 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors shadow-lg" onClick={handleDeleteImage}>
                                                <MdOutlineDeleteOutline className="w-5 h-5" />
                                            </button>
                                        </div>
                                    )}
                            </div>
                            <input type="file" name="image" accept="image/*" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={handleImageChange}  />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center w-full mt-5">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};